import { useTranslation } from 'react-i18next'

import { RadioGroupModal } from '../../../Radio'
import {
  CHATROOM_MESSAGE_FIELD_NAME_TYPE,
  QA_NAME_CHATROOM_MESSAGE_TYPE_MODAL,
} from '../../Chatroom.constants'

import { CHATROOM_MESSAGE_TYPE_MODAL_INITIAL_VALUES } from './ChatroomMessageTypeModal.constants'
import {
  getChatroomMessageTypeOptions,
  isPublicChatroomType,
} from './ChatroomMessageTypeModal.utils'

function ChatroomMessageTypeModal({ onClose, onSubmit }) {
  const { t } = useTranslation()

  function getOptions() {
    return getChatroomMessageTypeOptions({ t })
  }

  function handleSubmit(values) {
    onSubmit(isPublicChatroomType(values[CHATROOM_MESSAGE_FIELD_NAME_TYPE]))
  }

  return (
    <RadioGroupModal
      formFieldsProps={{
        getOptions,
        name: CHATROOM_MESSAGE_FIELD_NAME_TYPE,
        submitProps: { title: 'Modal.ApplyBtnKey' },
        title: t('Chatroom.MessageTypeModalTextKey'),
      }}
      initialValues={CHATROOM_MESSAGE_TYPE_MODAL_INITIAL_VALUES}
      qaName={QA_NAME_CHATROOM_MESSAGE_TYPE_MODAL}
      title={t('Chatroom.MessageTypeModalTitleKey')}
      onClose={onClose}
      onSubmit={handleSubmit}
    />
  )
}

export default ChatroomMessageTypeModal
